import axios from "axios";
import config from "@Config/index";

interface Options {
  url_path?: string;
  params?: Record<string, any>;
}

const getPartnerAsync = (id: string, options: Options = {}) => {
  options.url_path = options.url_path || "/leads/partners";
  options.params = options.params || {};

  const url = `${config.API_URL}${options.url_path}/${id}`;

  return axios.get(url, {
    params: options.params,
    withCredentials: true,
  });
};

export const getCustomFormFields = async (partnerId: string) => {
  const url = `${config.API_URL}/api/v0/partner_custom_form_field_configs?partner_id=${partnerId}`;

  return axios.get(url, {
    withCredentials: true,
  });
};

export default getPartnerAsync;
